import { useEffect } from 'react';
import './RetellAIChat.css';

const RetellAIChat = () => {
  useEffect(() => {
    console.log('RetellAIChat component mounted');
    
    // Check if script already exists to prevent duplicates
    const existingScript = document.getElementById('retell-widget');
    if (existingScript) {
      console.log('Retell script already exists');
      return;
    }

    // Create and append the Retell AI widget script
    const script = document.createElement('script');
    script.id = 'retell-widget';
    script.src = 'https://dashboard.retellai.com/retell-widget.js';
    script.type = 'module';
    script.setAttribute('data-public-key', 'public_key_5d950e299d3cb337269b2');
    script.setAttribute('data-agent-id', 'agent_d00910c3ed5ffc87dfa21f593e');
    script.setAttribute('data-agent-version', '0');
    script.setAttribute('data-title', 'ezOCM AI Assistant');
    
    // Add load and error handlers
    script.onload = () => {
      console.log('Retell script loaded successfully');
    };
    
    script.onerror = (error) => {
      console.error('Failed to load Retell script:', error);
    };
    
    console.log('Appending Retell script to body');
    document.body.appendChild(script);

    // Cleanup function to remove script when component unmounts
    return () => {
      console.log('RetellAIChat component unmounting');
      const scriptToRemove = document.getElementById('retell-widget');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  return null; // The widget creates its own UI
};

export default RetellAIChat;